var map = {
	"./BTL_sRGB_2023_Winter-Warmers_Parmigiana_Macro.png": "2f0b",
	"./Complex-Falafel.png": "cc8f",
	"./Complex-Poke.png": "d729",
	"./Complex-Sushi.png": "96e6",
	"./Complex-Wrap.png": "7906",
	"./Courier-1.png": "04a5",
	"./Courier-2.png": "7a20",
	"./Courier-3.png": "1a23",
	"./Courier-4.png": "87f0",
	"./Courier-5.png": "712d",
	"./Courier-6.png": "7091",
	"./Customer-1.png": "8fe2",
	"./Customer-2.png": "1403",
	"./Customer-3.png": "b2cc",
	"./Customer-4.png": "b016",
	"./Customer-5.png": "fe51",
	"./Customer-6.png": "048a",
	"./Customer-7.png": "e16a",
	"./Customer-8.png": "b8ca",
	"./Do-Contrast_ratio.png": "67b5",
	"./Do_Horizontal_logo.png": "1ab5",
	"./Do_Logo_exclusion.png": "813b",
	"./Dont_Busy_backgrounds.png": "6803",
	"./Dont_Shadows_and_gradients.png": "60ba",
	"./Dont_Stretch_warp_compress.png": "b858",
	"./Employee-1.png": "9bc4",
	"./Employee-2.png": "e5fc",
	"./Employees-1.png": "b6ca",
	"./Iphone_Cam_03-Final-Cupcake.png": "4929",
	"./Lifestyle_H_RGB_Global_2022_RestaurantAwards_PokePrep.png": "576e",
	"./Logo_Hor_Mozza.png": "c608",
	"./Logo_Hor_Orange.png": "2c29",
	"./Logo_House.png": "33a0",
	"./Nav_House.png": "119f",
	"./Nav_Logo.png": "c9c4",
	"./Object-1.png": "1b5b",
	"./Object-2.png": "5b3d",
	"./Object-3.png": "1ccc",
	"./Object-4.png": "1c5e",
	"./Object-D.png": "c30e",
	"./Object-E.png": "6946",
	"./Object-F.png": "3769",
	"./Restaurant-Facade.png": "7bb2",
	"./RestoPartner-1.png": "9b84",
	"./RestoPartner-2.png": "277a",
	"./Simple-Burger.png": "67f5",
	"./Simple-Drink.png": "d8d6",
	"./Simple-Fries.png": "2588",
	"./Simple-Macaroni.png": "e128",
	"./Simple-Mash.png": "7ca1",
	"./Simple-Noodles.png": "a60c",
	"./Simple-Pizza.png": "4e92",
	"./Simple-Ramen.png": "e56e",
	"./Simple-Salad.png": "3e14",
	"./Simple-Sushi.png": "0931",
	"./Simple-Taco.png": "bcaf",
	"./Support-1.png": "fe1f",
	"./Support-2.png": "06d9",
	"./Support-3.png": "7c3a",
	"./Support-4.png": "a95d",
	"./Support-5.png": "7674",
	"./alt.png": "8f39",
	"./art-direction-tips.png": "9a52",
	"./associated-brand.png": "40b8",
	"./associated-brands.png": "f756",
	"./base-colours.png": "9b3f",
	"./bike-man.png": "8c16",
	"./bike-woman.png": "7e8e",
	"./bike.png": "a3ca",
	"./blt.png": "869d",
	"./brand-voice.png": "63bf",
	"./burger.png": "d957",
	"./burrito-bowl.png": "2fda",
	"./busy-background.png": "ccab",
	"./chicken-home.png": "dd6b",
	"./chinese.png": "a908",
	"./co-branding-logo-KFC.png": "6708",
	"./co-branding-logo-ben-jerrys.png": "6122",
	"./co-branding-logo-burger-king.png": "cdd5",
	"./co-branding-logo-dominoes.png": "9b45",
	"./co-branding-logo-dunkin.png": "6bb1",
	"./co-branding-logo-greggs.png": "0da9",
	"./co-branding-logo-mcdonalds.png": "b2cc9",
	"./co-branding-logo-papa-johns.png": "7972",
	"./co-branding-logo-starbucks.png": "4fde",
	"./co-branding-logo-subway.png": "107f",
	"./co-branding-logo-tacobell.png": "374b",
	"./co-branding-logos-intro.png": "3b7b",
	"./co-branding-logos-primary.png": "caa4",
	"./co-branding-orange-background.png": "07cc",
	"./co-branding-razor.png": "f36f",
	"./co-branding-world-JET-4.png": "262b",
	"./co-branding-world-JET-background-1.png": "aa1f",
	"./co-branding-world-JET-background-2.png": "d4de",
	"./co-branding-world-JET-background-3.png": "3fd7",
	"./co-branding-world-RP-2.png": "10e1",
	"./co-branding-world-RP-background-4.png": "a0d6",
	"./co-branding-world-RP-background-5.png": "3cda",
	"./co-branding-world-RP-background.png": "449e",
	"./co-branding.png": "938f",
	"./cobranding-16x9.png": "2f2d",
	"./cobranding.png": "37193",
	"./cobrandingnew.png": "9d9e",
	"./color-palette-mobile.png": "3784",
	"./color-palette.png": "65f4",
	"./colors-hero.png": "eeff",
	"./colour-aubergine.png": "055a",
	"./colour-base-colours.png": "461c",
	"./colour-berry.png": "a666",
	"./colour-charcoal.png": "5118",
	"./colour-cupcake.png": "4408",
	"./colour-mozzarella.png": "5353",
	"./colour-orange.png": "6e7d",
	"./colour-tomato.png": "e060",
	"./colour-turmeric.png": "f5f5",
	"./colours-bg.png": "2440",
	"./colours-nav.png": "746e",
	"./colours.png": "72d4",
	"./composition-16x9.png": "59a9",
	"./composition-nav.png": "6d99",
	"./composition.png": "b7f7",
	"./contrast-ratio.png": "ee9f",
	"./cookies.png": "c0e2",
	"./corner-house.png": "7900",
	"./corporate-image.png": "f72d",
	"./corporate.png": "f026",
	"./courier-7.png": "ded9",
	"./courier-image.png": "5345",
	"./courier.png": "e533",
	"./custom-grid.png": "901f",
	"./disposables.png": "27a2",
	"./doughnut.png": "e4b3",
	"./dounuts.png": "75c9",
	"./download-orange-horizontal.png": "e9d7",
	"./download-orange-house.png": "becb",
	"./download-orange-stacked.png": "3bdb",
	"./download-white-horizontal.png": "4ed8",
	"./download-white-stacked.png": "a3d2",
	"./dropper.png": "7fc5",
	"./food-image.png": "50d4",
	"./food.png": "1419",
	"./horizontal-logo.png": "344a",
	"./house-orange.png": "e5ad",
	"./house-square.png": "d359",
	"./house-white.png": "ddcd",
	"./hybrid-dessert.png": "8c0f",
	"./hybrid-image-1.png": "bc1f",
	"./hybrid-image-2.png": "e8a8",
	"./hybrid-image-3.png": "29e1",
	"./hybrid-valentines.png": "db9b",
	"./iPhone-2024.png": "34cf",
	"./icon-base-colour.png": "f1f6",
	"./icon-base.png": "e769",
	"./icon-custom-grid.png": "1105",
	"./icon-promo-badge-charcoal.png": "b1d1",
	"./icon-promo-badge-mozzarella.png": "8b4c",
	"./icons-nav.png": "6b82",
	"./icons.png": "c42d",
	"./illustration-colours.png": "af65",
	"./illustration-falafel.png": "4b9b",
	"./illustration-simple-and-complex.png": "8053",
	"./illustration.png": "8518",
	"./info-and-maps.png": "cd14",
	"./info.png": "7c12",
	"./infographic.png": "69ee",
	"./iphone.png": "eea5",
	"./katy-perry.png": "39d5",
	"./laptop-mobile.png": "0fc3",
	"./laptop.png": "1104",
	"./logo-exclusion-zone.png": "4385",
	"./logo-exclusion.png": "9c84",
	"./logo-image-1.png": "f5b2",
	"./logo-image-2.png": "569f",
	"./logo-image-3.png": "bec0",
	"./logo-image-4.png": "855f",
	"./logo-image-5.png": "c2e5",
	"./logo-minimum-sizes.png": "2def",
	"./logo-orange.png": "3719",
	"./logo-white.png": "06f1",
	"./logos-hero.png": "a4b2",
	"./logos-nav.png": "4c32",
	"./logos.png": "4073",
	"./meeting.png": "2917",
	"./mexican.png": "6ea6",
	"./milkshake.png": "cbc3",
	"./milkshakes.png": "a7eb",
	"./motion.png": "c5b9",
	"./moving-home.png": "d494",
	"./network-teams.png": "8900",
	"./new-food-burger.png": "f6f7",
	"./new-food-drink.png": "8aae",
	"./new-food-fries.png": "d4d7",
	"./new-food-indian.png": "c820",
	"./new-food-noodles.png": "bb47",
	"./new-food-pasta.png": "8e7f",
	"./new-food-pizza.png": "f72b",
	"./new-food-salad.png": "900d",
	"./new-food-sushi.png": "ccb2",
	"./new-food-taco.png": "62a3",
	"./new-food-thai.png": "fd28",
	"./new-object-bag.png": "9ace",
	"./new-object-ballons.png": "cc1e",
	"./new-object-celebration.png": "aa30",
	"./new-object-delivery.png": "eff7",
	"./new-object-joyful.png": "984a",
	"./new-object-lock.png": "5438",
	"./new-object-megaphone.png": "d3b0",
	"./new-object-order.png": "3c29",
	"./new-object-search.png": "1795",
	"./new-object-speech.png": "e902",
	"./new-people-chef-holding-bags.png": "1830",
	"./new-people-chef-order-pad.png": "c9c0",
	"./new-people-courier-bike.png": "3ea4",
	"./new-people-courier-delivery.png": "dd95",
	"./new-people-courier-walk.png": "6983",
	"./new-people-customer-employee-branding.png": "c1f1",
	"./new-people-customer-order-joy.png": "1926",
	"./new-people-customer-using-app.png": "af5d",
	"./new-people-employee-support.png": "6dd1",
	"./new-people-jet-employee.png": "bb81",
	"./orange-15.png": "7c34",
	"./orange-30.png": "c6b0",
	"./orange-7.5.png": "e0f1",
	"./orange-circle.png": "d755",
	"./orange-horizontal.png": "32be",
	"./orange-house.png": "43f7",
	"./orange-razor.png": "617e",
	"./orange-stacked.png": "004b",
	"./pad-thai.png": "7ff3",
	"./photo-casting.png": "1394",
	"./photo-colour.png": "be00",
	"./photo-courier.png": "b33f",
	"./photo-donut-lifestyle.png": "df3c",
	"./photo-donut-studio.png": "16c5",
	"./photo-food-moments.png": "8f2e",
	"./photo-life-studio.png": "0b8d",
	"./photo-lifestyle-casting.png": "73fe",
	"./photo-lifestyle-colour.png": "c651",
	"./photo-lifestyle-food-moments.png": "3cac",
	"./photo-lifestyle-lighting.png": "7d25",
	"./photo-lifestyle-location.png": "f530",
	"./photo-lifestyle-props.png": "dc65",
	"./photo-lifestyle-resto-partner.png": "0cda",
	"./photo-lighting.png": "152f",
	"./photo-location.png": "3b14",
	"./photo-office.png": "7707",
	"./photo-party-studio.png": "0ee1",
	"./photo-props.png": "fe7d",
	"./photo-restaurant-partner.png": "499a",
	"./photo-smoothie-studio.png": "72af",
	"./photo-spectrum-line-mobile.png": "3050",
	"./photo-spectrum-line.png": "8f78",
	"./photo-studio-atl-btl.png": "4057",
	"./photo-studio-lighting.png": "e5df",
	"./photo-studio-pizza-crumbs.png": "8dc5",
	"./photo-studio-razor-15.png": "8c8e",
	"./photo-studio-razor-30.png": "edab",
	"./photo-studio-razor-7.5.png": "b93a",
	"./photography-16x9.png": "dc7e",
	"./photography.png": "274a",
	"./pizza-day.png": "b04d",
	"./pizza-plate.png": "e3a7",
	"./pizza.png": "7237",
	"./presentation-hero.png": "f118",
	"./presentation.png": "0f9c",
	"./press-media-hero.png": "d276",
	"./press.png": "b3e4",
	"./product.png": "52bb",
	"./rainbow-sushi.png": "c93a",
	"./ramen.png": "3e19",
	"./recently-moved.png": "9354",
	"./shadows-and-gradients.png": "9a48",
	"./shape-or-container.png": "303b",
	"./social-media.png": "5df5",
	"./stretch-warp-compress.png": "432a",
	"./sushi-image.png": "e0a4",
	"./sushi.png": "db28",
	"./taco-yellow.png": "135d",
	"./taco.png": "928e",
	"./tacos.png": "13e2",
	"./tomato-left.png": "463f",
	"./tomato-right.png": "3e9b",
	"./type-nav.png": "feac",
	"./typography-image-1.png": "f630",
	"./typography-image-2.png": "7a2c",
	"./typography.png": "4216",
	"./white-horizontal-mobile.png": "3ff9",
	"./white-horizontal.png": "7c2f",
	"./white-house-mobile.png": "ea42",
	"./white-stacked-mobile.png": "31ac",
	"./white-stacked.png": "368a",
	"./woman-bag.png": "2a21",
	"./woman-helmet.png": "b99b",
	"./woman-noodles.png": "6808",
	"./yellow-bg.png": "52e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";